// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleBlogPage_blog-parent-div__ClmAS::-webkit-scrollbar {
  display: none;
}

.SingleBlogPage_iframe-div__Y8tEj::-webkit-scrollbar{
    display: none;
}

.SingleBlogPage_iframe-element__8p9mO{
    width:100%;
    overflow-y:hidden;
}

.SingleBlogPage_iframe-element__8p9mO::-webkit-scrollbar{
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Blogs/SingleBlogPage/SingleBlogPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".blog-parent-div::-webkit-scrollbar {\n  display: none;\n}\n\n.iframe-div::-webkit-scrollbar{\n    display: none;\n}\n\n.iframe-element{\n    width:100%;\n    overflow-y:hidden;\n}\n\n.iframe-element::-webkit-scrollbar{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog-parent-div": `SingleBlogPage_blog-parent-div__ClmAS`,
	"iframe-div": `SingleBlogPage_iframe-div__Y8tEj`,
	"iframe-element": `SingleBlogPage_iframe-element__8p9mO`
};
export default ___CSS_LOADER_EXPORT___;
